import React from 'react';
import { Table } from 'react-bootstrap';
import Head from "./components/Head";
import Row from "./components/Row";

const BidderSpy = ({ params, report, onAffidBtn, onSortChange }) => {
    const rows = report.map((row, index) => (<Row params={params} row={row} key={index} onAffidBtn={onAffidBtn} />));

    return (
        <Table bordered responsive>
            <Head params={params} onSortChange={onSortChange}/>
            <tbody>
                {rows}
            </tbody>
        </Table>
    )
};

export default BidderSpy;



// WEBPACK FOOTER //
// ./src/scenes/BidderSpy/components/Table/index.js